import 'core-js/stable'
import Vue from 'vue'
import store from './store'
import './plugins/axios'
import i18n from './plugins/lang'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import babelPolyfill from 'babel-polyfill'
import { CFormTextarea } from '@coreui/vue'
import { CAlert } from '@coreui/vue';
import LottiePlayer from 'lottie-player-vue';

import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';

const moment = require('moment');
import VueMoment from 'vue-jalali-moment';
require('moment/locale/fa');




Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(LottiePlayer)
Vue.use(VueFileAgent)
Vue.use(require('vue-jalali-moment'));
Vue.moment.locale('fa');

Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  },
  created() { 
  }
})
Vue.use(VuePlyr, {
  plyr: {}
})